import { render, staticRenderFns } from "./TicketSystem.vue?vue&type=template&id=4ff3126a&"
import script from "./TicketSystem.vue?vue&type=script&lang=js&"
export * from "./TicketSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports